<app-header (Navigate)="navigateTo($event)"></app-header>
<ngx-spinner></ngx-spinner>
<div class="wrapper">
  <section class="banner-sect" #home>
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8">
          <h1>{{ "LANDING.LANDING_TITLE" | translate }}</h1>
          <p>
            {{ "LANDING.LANDING_MESSAGE" | translate }}
          </p>
          <button class="btn btn-theme" [routerLink]="['/signup']">
            {{ "LANDING.JOIN_NOW" | translate }}
          </button>
        </div>
      </div>
    </div>
  </section>
  <section class="gray-bg about-sect" #aboutus>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-5">
          <h2 class="mb-3">
            {{ landingData.ABOUT_US.heading }}
          </h2>
          <h1 class="heading after-border text-uppercase">
            {{ landingData.ABOUT_US.title }}
          </h1>
          <p class="text-secondary mt-5">
            {{ landingData.ABOUT_US.description }}
          </p>
          <!-- <button class="btn btn-theme mt-2">View More</button> -->
        </div>
        <div class="col-12 col-md-12 col-lg-7 text-center">
          <img [src]="landingData.ABOUT_US.thumbnail" class="mw-100" />
        </div>
      </div>
    </div>
  </section>
  <section class="choose-investiflix-sect">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 text-center">
          <h2 class="after-border">{{ landingData.LOREUM_IPSUM.title }}</h2>
          <p class="text-secondary mt-5">
            {{ landingData.LOREUM_IPSUM.description }}
          </p>
        </div>
      </div>
    </div>

    <ul class="choose-list">
      <li *ngFor="let data of landingData.LOREUM_IPSUM.content">
        <div class="font-24">
          <span class="{{ data.icon }}"></span>
        </div>
        <h5 class="my-3">{{ data.title }}</h5>
        <p class="mb-0">
          {{ data.description }}
        </p>
      </li>
    </ul>
  </section>
  <section class="courses-sect gray-bg" #series>
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 text-center">
          <h2 class="after-border">{{ landingData.COURSES.title }}</h2>
          <p class="text-secondary mt-5">
            {{ landingData.COURSES.description }}
          </p>
        </div>
      </div>
    </div>
    <div class="following-courses-list">
      <div
        class="following-courses"
        *ngFor="let course of landingData.COURSES.content"
      >
        <img [src]="course.thumbnail" class="mw-100" alt="" />
        <div>
          <h5>{{ course.name }}</h5>
          <p>
            {{ course.duration }} <span class="dots"></span>{{ course.lecture }}
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="people-sect" *ngIf="testimonials.length > 0">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-12 col-md-8 text-center">
          <h2 class="after-border">{{ landingData.PEOPLE_REVIEW.title }}</h2>
        </div>
      </div>
      <owl-carousel-o [options]="generCarousel"  (dragging)="isDragging" *ngIf="testimonialsLoader">
        <ng-container *ngFor="let review of testimonials">
          <ng-template carouselSlide>
            <div class="people-box">
              <h5 class="orange-link mb-3">{{ review.title }}</h5>
              <!-- <p class="mb-3">
                {{ review.title }}
              </p> -->
              <div class="d-flex align-items-start ">
                <div class="people-img">
                  <img [src]="review.image" alt="" />
                </div>
                <div class="ml-2">
                  <h5>{{ review.name }}</h5>
                  <p class="mb-0 text-secondary">{{ review.description }}</p>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
      <div class="loader" *ngIf="!testimonialsLoader">
        <span class="icon-loader spin"></span>
      </div>
    </div>
    
  </section>
  <section class="gray-bg plan-sect" #plan>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 col-md-6">
          <h6 class="sub-head">{{ landingData.PLANS.heading }}</h6>
          <h1 class="my-4">{{ landingData.PLANS.title }}</h1>
          <p class="text-secondary">
            {{ landingData.PLANS.description }}
          </p>
          <!-- <button type="button" class="btn btn-theme">Find Out More</button> -->
        </div>
        <div class="col-12 col-md-6">
          <div class="plan-box" *ngFor="let plan of landingData.PLANS.content">
            <div>
              <h5 class="mb-2">
                <b> {{ plan.name }} </b>
              </h5>
              <p class="font-12 mb-0">
                {{ plan.description }}
              </p>
            </div>
            <div>
              <h1>
                <span>{{ plan.currency }}</span
                >{{ plan.price }}
                <!-- <span class="text-secondary">{{ plan.plan_type }}</span> -->
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="qution-sect" *ngIf="array.length > 0">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-12 col-md-8 text-center">
          <h2 class="after-border">{{ "LANDING.FAQ_TITLE" | translate }}</h2>
          <p class="text-secondary mt-5 mb-0">
            {{ "LANDING.FAQ_MESSAGE" | translate }}
          </p>
        </div>
        <div class="col-md-12">
          <div class="collapse-list" *ngIf="array.length > 0">
            <div class="collapse-box">
              <mat-accordion *ngFor="let faq of array; index as i">
                <mat-expansion-panel
                  hideToggle="false"
                  *ngIf="faq?.zeroIndex"
                  [expanded]="step == i && panelOpenState == false"
                  (opened)="setStep(i)"
                >
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <p
                        class="mb-0 text-white"
                        [innerHtml]="faq.zeroIndex?.question | uppercase"
                      ></p>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <p
                    class="text-secondary"
                    [innerHtml]="faq.zeroIndex?.answer"
                  ></p>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
            <div class="shaprater-line"></div>
            <div class="collapse-box">
              <mat-accordion *ngFor="let faq of array; index as j">
                <mat-expansion-panel
                  hideToggle="false"
                  *ngIf="faq?.firstIndex"
                  [expanded]="step1 == j && panelOpenState == true"
                  (opened)="setStep1(j)"
                >
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <p
                        class="mb-0 text-white"
                        [innerHtml]="faq.firstIndex?.question"
                      ></p>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <p
                    class="text-secondary"
                    [innerHtml]="faq.firstIndex?.answer"
                  ></p>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
          <div class="loader" *ngIf="array.length == 0">
            <span class="icon-loader spin"></span>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<app-footer class="landing-footer"></app-footer>
